const authority = "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_yWr82KzUI";
const cognitoDomain = "https://alonbl-auth-test1.rnd-pg2.dev.internal.exodigo.ai";
const clientId = "42dji42qvgbh96fi24q0cn0pbp";

const selfUri = new URL(window.location.href);
selfUri.search = "";

const config = {
  authConfig: {
    authority: authority,
    client_id: clientId,
    redirect_uri: selfUri.href,
    response_type: "code",
    scope: "email openid",
  },
  logoutURL: `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(selfUri.href)}`,
};

export default config;
